var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxBoldShopRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.99 17.338v-2.84a.96.96 0 0 1 1.29-.9c.26.09.52.15.79.19.12.02.24.04.36.04.15.02.31.03.46.03 1.11 0 2.21-.41 3.08-1.12.83.71 1.9 1.12 3.04 1.12 1.14 0 2.2-.39 3.03-1.11.86.7 1.94 1.11 3.04 1.11.17 0 .35-.01.51-.03.12-.01.22-.02.33-.04.3-.04.57-.12.84-.21a.96.96 0 0 1 1.27.9v2.86c0 2.65-2.15 4.81-4.81 4.81H7.8c-2.65 0-4.81-2.15-4.81-4.81z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7 5.932c-.4-2.9-1.72-4.08-4.53-4.08H6.82c-2.82 0-4.13 1.18-4.54 4.11l-.26 2.64c-.1 1.03.18 2.03.79 2.81.73.95 1.85 1.49 3.1 1.49 1.21 0 2.37-.61 3.11-1.58.65.97 1.76 1.58 3 1.58s2.33-.58 2.99-1.54c.74.95 1.89 1.54 3.08 1.54 1.28 0 2.43-.57 3.15-1.57.58-.77.84-1.74.74-2.74l-.28-2.66zm-11.2 1.8a.749.749 0 1 1 0-1.5h3a.749.749 0 1 1 0 1.5h-3z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxBoldShopRemove);
export default __webpack_public_path__ + "static/media/vuesax-bold-shop-remove.5eced1d9213d532e02e27d0b6069102a.svg";
export { ForwardRef as ReactComponent };